export const ALLOW_QUERY_PARAMS = false;
export const LOCATION_AND_DEVICE_KEY = 'use_location_and_device';
